import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { webPricing } from "../design/DummyData";
import "../../sass/design.scss";
import FAQAccordion from "../../../components/FAQAccordion";
import TextSlicer from "../../../components/TextSlicer";
import MetaData from "../../../components/MetaData";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

const webDevFaq1 = [
  "Customer-Centric Approach",
  "Competent Developers",
  "Timely Work Completion",
];

const webDevFaq2 = [
  "Custom CRM Development",
  "Custom Web App Development",
  "E-Commerce Web App Development",
  "Social Media Web App Integration",
  "Third-Party Web App Integration",
  "Responsive Web Application Design",
  "Enterprise-Scale Web Applications",
];

const webDevFaq3 = [
  "Personal meeting where we discuss your business needs and long-term vision.",
  "Analyze your business, competitors, and identify key business KPIs.",
  "Design, develop, test, and deliver an optimized business web application.",
];

const webDevFaq4 = [
  "We integrate third-party applications into your website ecosystem.",
  "Our team works to connect your new application with existing systems.",
  "Sometimes integration becomes complex due to different technologies and versions.",
  "In such cases, building a new optimized web application may reduce long-term costs.",
];

const webDevFaq5 = [
  "We develop fully responsive web applications.",
  "Your website will work smoothly across all devices including mobile, tablet, and desktop.",
  "Our goal is to provide a consistent user experience across browsers and platforms.",
];

const webDevFaq6 = [
  "High performance through component-based architecture",
  "Smooth and fast page interactions",
  "Better code reusability and scalability",
  "Efficient data handling and updates",
  "Responsive and user-friendly interfaces",
];

const summary = `Softorithm's web development services combine technical expertise with deep industry knowledge to deliver robust, scalable, and secure web applications that drive business efficiency and growth across all sectors.`;

const WebDevelopment = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="design">
      <MetaData
        metaTitle={"Web App Development"}
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero with Google Review */}
      <GoogleReviewSection
        title="Web Application Development Services"
        subtitle="Comprehensive web development services including ERP, HRM, PLM, PIM systems, and healthcare applications. Building scalable solutions trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      <div className="page_body">
        <div className=" mt-5">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center mb-4 pb-2 about_rgt_cont">
                <h4 className="fw-semibold fs-22 mb-4">
                  Web Application Development Service You Need!
                </h4>
                <TextSlicer
                  text={`Businesses all over the world rely on an effective and user-friendly website. Websites act as powerful tools for businesses around the globe to attract the relevant audience to your website. This is the point where web application development comes in. SoftoRithm Technologies is proud to inform you that our team of competent web app developers is here to offer you their services. We will cater all your business requirements to offer you the best web application development services for your online running business.
               `}
                />
                <TextSlicer
                  text={`To keep your business “on-the-go”, web application development is a pre-requisite for the evolving digital business. Businesses need to make sure that all things related to their operations are functioning correctly throughout the digital landscape. This is very crucial to ensure the smooth operation of your business. We are providing web application development services for a wide audience.
               `}
                />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={9}>
              <Row className="justify-content-center">
                {(webPricing || []).map((price2, key) => (
                  <Col md={6} lg={4} xl={4} key={key}>
                    <Card className="pricing-box ribbon-box right">
                      <CardBody className="p-4 m-2">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 me-3">
                            <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                            <p className="text-muted mb-0">{price2.purpose}</p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <div className="avatar-title bg-light rounded-circle text-primary">
                              <i className={"fs-20 " + price2.icon}></i>
                            </div>
                          </div>
                        </div>

                        <hr className="my-4 text-muted" />
                        <div className="scrollable-list">
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {(price2.points || []).map((point, key) => (
                              <li key={key}>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">{point}</div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="mt-3 pt-2">
                          <Link
                            to="/contact-us"
                            className={`btn btn-success w-100`}
                          >
                            Get Quote
                          </Link>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text">
                    Get in touch with us to discuss the details regarding your
                    digital platform and the services we can provide for future
                    web application development. We are happy to be of service!
                  </p>
                </Col>
                <Col lg={4} md={5} sm={12} className="text-center text-md-center">
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">Frequently Asked Questions</h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question:
                            "SoftoRithm Technologies - What makes us the right pick?",
                          points: webDevFaq1,
                        },
                        {
                          question:
                            "What type of custom web application development services we offer?",
                          points: webDevFaq2,
                        },
                        {
                          question:
                            "How you deal with complex web development projects?",
                          points: webDevFaq3,
                        },
                        {
                          question:
                            "How you integrate with existing systems and third-party tools?",
                          points: webDevFaq4,
                        },
                        {
                          question:
                            "How do you approach responsiveness for custom web applications?",
                          points: webDevFaq5,
                        },
                        {
                          question:
                            "How does our React JS frontend service help build fast SPAs?",
                          points: webDevFaq6,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDevelopment;
